import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Textarea } from '../ui/textarea';
import { api, fmtShort, isoDate } from './utils';

const defaultNote = (plan, status) => {
  const today = fmtShort(isoDate(new Date()));
  if (status === 'Escalated') return `Escalated ${today} – discussed with Robyn.`;
  const due = plan.overdue_reason === 'failed' ? `Failed payment ${fmtShort(plan.last_failed_date)}` : `Payment due ${fmtShort(plan.next_due)}`;
  return `${due} – reminder sent ${today}.`;
};

export const FollowUpDialog = ({ plan, status = 'Follow Up Sent', onClose, onSaved }) => {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (plan) setNote(defaultNote(plan, status)); }, [plan, status]);

  const save = async () => {
    setSaving(true);
    try {
      const saved = await api(`/${plan.id}`, { method: 'PUT', body: { manual_status: status, note } });
      toast.success(`Marked as ${status}`);
      onSaved(saved);
    } catch (e) { toast.error(e.message); } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!plan} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="follow-up-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">{status === 'Escalated' ? 'Escalate account' : 'Follow-up sent'}</DialogTitle>
          <DialogDescription>
            {plan?.client_name}: status stays "{status}" until Halaxy records a new payment.
            {status === 'Escalated' && ' Discuss repeated missed payments with Robyn before escalating.'}
          </DialogDescription>
        </DialogHeader>
        <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} data-testid="follow-up-note-input" />
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="follow-up-cancel-btn">Cancel</Button>
          <Button onClick={save} disabled={saving} className="bg-[#3A3530] text-white hover:bg-[#2A2520]" data-testid="follow-up-save-btn">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
